// store.js

import { createStore, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
// import rootReducer from "./reducers"; // Your root reducer
import { encryptTransform } from "redux-persist-transform-encrypt";
import { ProjectName } from "../config";
import sessionStorage from "redux-persist/es/storage/session";
import { clearPersistedAuth } from "../utils/auth";

const PERSIST_KEYS = ["persist:local", "persist:session", "persist:language"];

const encryptor = encryptTransform({
  secretKey: ProjectName, // Use a strong secret key
  onError: function (error) {
    console.error("Encryption error:", error);
    clearPersistedAuth();
  },
});
// const persistConfig = {
//   key: "root",
//   storage,
//   transforms: [encryptor],
// };


const localPersistConfig = {
  key: "local",
  storage,
  transforms: [encryptor],
};

const sessionPersistConfig = {
  key: "session",
  storage: sessionStorage,
  transforms: [encryptor],
};

const languagePersistConfig = {
  key: "language",
  storage,
  transforms: [encryptor],
};


const userReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case "SET_DATA":
      return {
        ...state,
        data: action.payload,
      };
    case "SET_PERMISSIONS": {
      const permissions = Array.isArray(action.payload) ? action.payload : [];
      const current = state.data || {};

      return {
        ...state,
        data: {
          ...current,
          permissions,
          user: current?.user
            ? {
                ...current.user,
                user_data: {
                  ...current.user.user_data,
                  permissions,
                },
              }
            : current.user,
        },
      };
    }
    default:
      return state;
  }
};

const sessionReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case "SESSION_DATA":
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

// Get initial language from localStorage or default to 'en'
const getInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const storedLang = localStorage.getItem('i18nextLang');
    if (storedLang) {
      return {
        language: storedLang,
        direction: storedLang === 'ar' ? 'rtl' : 'ltr'
      };
    }
  }
  return { language: 'en', direction: 'ltr' };
};

const languageReducer = (state = getInitialLanguage(), action) => {
  switch (action.type) {
    case "SET_LANGUAGE":
      return {
        ...state,
        language: action.payload.language,
        direction: action.payload.direction,
      };
    default:
      return state;
  }
};



const localPersistedReducer = persistReducer(localPersistConfig, userReducer);
const sessionPersistedReducer = persistReducer(sessionPersistConfig, sessionReducer);
const languagePersistedReducer = persistReducer(languagePersistConfig, languageReducer);

const rootReducer = combineReducers({
  user: localPersistedReducer,
  session: sessionPersistedReducer,
  language: languagePersistedReducer,
});

// Clear corrupt persisted state that can block app startup
if (typeof window !== "undefined") {
  PERSIST_KEYS.forEach((key) => {
    const value = localStorage.getItem(key) ?? sessionStorage.getItem(key);
    if (!value) return;

    try {
      JSON.parse(value);
    } catch (error) {
      console.error(`Removing invalid persisted state for ${key}:`, error);
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
  });
}

// Store and persistor
const store = createStore(rootReducer);
const persistor = persistStore(store, null, () => {
  const state = store.getState();
  const user = state?.user?.data;

  if (user && Object.keys(user).length > 0 && !user?.token) {
    store.dispatch({ type: "SET_DATA", payload: {} });
  }
});

export { store, persistor };